import { useCallback, useRef, useState } from 'react';
import {
  FlatList,
  NativeScrollEvent,
  NativeSyntheticEvent,
} from 'react-native';
import useLayout from './useLayout';

const usePagination = () => {
  const [layout, onLayout] = useLayout();
  const [activeIndex, setActiveIndex] = useState(0);
  const listRef = useRef<FlatList>(null);

  const onScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      const { contentOffset, layoutMeasurement } = event.nativeEvent;
      const index = Math.round(contentOffset.x / layoutMeasurement.width);

      setActiveIndex(index);
    },
    [],
  );

  const onPress = useCallback(
    (index: number) => {
      listRef.current?.scrollToOffset({ offset: layout.width * index });
    },
    [layout],
  );

  return {
    layout,
    listRef,
    activeIndex,
    onLayout,
    onScroll,
    onPress,
  };
};

export default usePagination;
